import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { ResumedUserType } from '@customTypes/user';

const useGetTeamMembers = () => {
  const [members, setMembers] = useState<ResumedUserType[]>([]);
  const [loading, setLoading] = useState(true);

  const getTeamMembers = useCallback(async (id: string) => {
    setLoading(true);
    try {
      const response = await api.get(`/teams/${id}/users`);
      setMembers(response.data);
    } catch (error) {
      toast.error('Erro ao carregar membros da equipe. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to fetch team members'), {
        error,
        teamId: id,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getTeamMembers,
    members,
    loading,
  };
};

export default useGetTeamMembers;
